package es.subastia.savedsearches

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import es.subastia.domain.usecase.ObserveAuthStateUseCase
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

import es.subastia.domain.model.SavedSearchModel
import es.subastia.domain.usecase.DeleteSearchUseCase
import es.subastia.domain.usecase.GetSavedSearchesUseCase
import kotlinx.coroutines.flow.first

sealed interface SavedSearchesUiState {
    data object Loading : SavedSearchesUiState
    data object NotLoggedIn : SavedSearchesUiState
    data class Success(val list: List<SavedSearchModel>) : SavedSearchesUiState
}

class SavedSearchesViewModel(
    private val observeAuthStateUseCase: ObserveAuthStateUseCase,
    private val getSavedSearchesUseCase: GetSavedSearchesUseCase,
    private val deleteSearchUseCase: DeleteSearchUseCase,
) : ViewModel() {

    @OptIn(ExperimentalCoroutinesApi::class)
    val uiState = observeAuthStateUseCase()
        .flatMapLatest { user ->
            if (user != null) {
                getSavedSearchesUseCase(user.uid).map {
                    SavedSearchesUiState.Success(it)
                }
            } else {
                flowOf(SavedSearchesUiState.NotLoggedIn)
            }
        }.stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5_000),
            initialValue = SavedSearchesUiState.Loading,
        )

    fun deleteSearch(searchId: String) {
        viewModelScope.launch {
            val user = observeAuthStateUseCase().first()
            if (user != null) {
                deleteSearchUseCase(searchId, user.uid)
            }
        }
    }
}
